import React from 'react';
import useInView from '../hooks/useInView';
import { BANKS } from '../data';

const BanksSection = ({ dark, t }) => {
  const [ref, inView] = useInView(0.1);

  return (
    <section
      id="banks"
      style={{
        padding: '120px 32px',
        background: dark ? '#0a0a0a' : '#fdf8ee',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Animated gold top border */}
      <div
        style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 2,
          background: 'linear-gradient(90deg,transparent,#c9a227,#e8c040,#c9a227,transparent)',
          animation: 'gradMove 4s linear infinite',
          backgroundSize: '200% auto',
        }}
      />

      <div ref={ref} style={{ maxWidth: 1280, margin: '0 auto' }}>
        {/* Header */}
        <div
          style={{
            textAlign: 'center',
            marginBottom: 72,
            opacity: inView ? 1 : 0,
            animation: inView ? 'fadeUp 0.7s cubic-bezier(.16,1,.3,1) forwards' : 'none',
          }}
        >
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: t.gold, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 16, fontWeight: 600 }}>
            — Our Partners —
          </div>
          <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 'clamp(2.2rem,4vw,3.5rem)', color: t.text, marginBottom: 16 }}>
            We Work With <span className="gold-text">All Major Banks</span>
          </h2>
          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 17, color: t.textSub, maxWidth: 560, margin: '0 auto' }}>
            Access competitive rates from India's most trusted financial institutions — all in one place.
          </p>
        </div>

        {/* Bank chips */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, justifyContent: 'center' }}>
          {BANKS.map((bank, i) => (
            <div
              key={bank}
              style={{
                padding: '16px 30px',
                background: dark ? '#111' : '#fff',
                border: `1.5px solid ${t.border}`,
                borderRadius: 60,
                fontFamily: "'Cormorant Garamond',serif",
                fontWeight: 600,
                fontSize: 17,
                color: t.textSub,
                transition: 'all 0.3s cubic-bezier(.16,1,.3,1)',
                cursor: 'default',
                boxShadow: dark ? 'none' : '0 2px 12px rgba(0,0,0,0.04)',
                opacity: inView ? 1 : 0,
                animation: inView ? `scaleIn 0.5s ${0.05 * i}s cubic-bezier(.16,1,.3,1) forwards` : 'none',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg,#c9a227,#e8c040)';
                e.currentTarget.style.color = '#0a0a0a';
                e.currentTarget.style.borderColor = '#c9a227';
                e.currentTarget.style.transform = 'translateY(-4px) scale(1.03)';
                e.currentTarget.style.boxShadow = '0 12px 32px rgba(201,162,39,0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = dark ? '#111' : '#fff';
                e.currentTarget.style.color = t.textSub;
                e.currentTarget.style.borderColor = t.border;
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = dark ? 'none' : '0 2px 12px rgba(0,0,0,0.04)';
              }}
            >
              {bank}
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div
          style={{
            marginTop: 48,
            padding: '28px',
            background: dark ? '#111' : '#fff',
            border: `1px solid ${t.border}`,
            borderRadius: 14,
            textAlign: 'center',
            opacity: inView ? 1 : 0,
            animation: inView ? 'fadeUp 0.7s 0.45s cubic-bezier(.16,1,.3,1) forwards' : 'none',
          }}
        >
          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, color: t.textMuted, margin: 0 }}>
            + All NBFC partners, Government Banks, and Co-operative Banks across India
          </p>
        </div>
      </div>
    </section>
  );
};

export default BanksSection;
